/**
 * Merges old and new data arrays based on a unique identifier key.
 *
 * @param {Array} oldData - Existing data array.
 * @param {Array} newData - New data array to merge.
 * @param {string} idKey - The property name that uniquely identifies an item (e.g., "personID" or "siteID").
 * @returns {Array} - The merged data array.
 */
export function mergeReduxStateData(oldData = [], newData = [], idKey) {
	// Create a map of the old data for quick lookup
	const existingDataMap = new Map(oldData.map((item) => [item[idKey], item]));

	// Process the new data: merge or add new items
	const updatedData = newData.map((item) => {
		const existingItem = existingDataMap.get(item[idKey]);

		if (!existingItem) {
			// If the item doesn't exist, add it
			return { ...item };
		}

		// Check if there are any changes (ignoring the idKey)
		const isChanged = Object.keys(item).some((key) => key !== idKey && item[key] !== existingItem[key]);

		// If changed, merge the data; otherwise, return the existing one
		return isChanged ? { ...existingItem, ...item } : existingItem;
	});

	// Return only the updated data (removes missing items)
	return updatedData;
}
